import axiosClient from "utils/api";
const URI = "/admin/reason";

export const getReasons = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Reasons:", error);
    throw error;
  }
};

export const addReason = async (payload) => {
  try {
    const response = await axiosClient().request({
      url: URI,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Add Reason:", error);
    throw error;
  }
};

export const updateReason = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Update Reason:", error);
    throw error;
  }
};

export const deleteReason = async (id) => {
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Delete Reason:", error);
    throw error;
  }
};

export const getAllReasons = async (payload) => {
  const URL = `${URI}/all`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get All Reasons:", error);
    throw error;
  }
};
